<template>
	<div>
		<el-dialog :title="$t('course_index.mail_record')" data-title="邮件记录" width="1200px" :close-on-click-modal="false" :visible="isdialog" :before-close="guanbitanchu">
			<el-table :data="list" border size="mini">
				<!-- <el-table-column type="selection" width="40"></el-table-column> -->
				<el-table-column prop="title" align="center" :label="$t('course_index.youjian_title')" data-name="邮件标题"></el-table-column>
				<el-table-column prop="create_time" align="center" :label="$t('course_index.time')" data-name="时间">
					<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
				</el-table-column>
				<el-table-column prop="object" align="center" :label="$t('course_index.student_list')" data-name="学生">
					
				</el-table-column>

				<el-table-column :label="$t('course_index.xuanzyoujian_info')" align="center" width="350">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" @click="class_notice(scope.row)">{{$t('index.info')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="page-pagination">
				<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
			</div>
			<el-dialog :title="$t('course_index.xuanzyoujian_info')" data-title="添加学生" width="1000px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false" append-to-body>
				<div class="html_br" v-html="course_info"></div>
			</el-dialog>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: {
		course_id:{
			type: Number,
			default:0
		},
		course_type:{
			type: String,
			default:''
		},
	},
	data() {
		return {
			isdialog:false,
			list: [],
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
			editFormVisible: false,
			course_info:'',
		}
	},
	watch: {
		course_id(v){
			if (v) {
				this.init();
			}else{
				this.isdialog=false
			}
		},
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "mailRecordList";
			var datas = {
				course_id: this_.course_id,
				course_type: this_.course_type,
				page:this_.pages.page,
				num:this_.pages.perpage,

			};
			this_.$post(url, datas).then((res) => {
				var list=res.list;
				for (var i = 0; i < list.length; i++) {
					if(list[i].object){
						if(typeof list[i].object == 'string'){
							list[i].object=this_.lang=='cn'?'全部发送':'Send all';
						}else{
							list[i]['object']=list[i].object.join(',');
						}
					}
				}
				// list.forEach(function(e,i) {
				// 	if (typeof e.object=='object'&&e.object&&e.object.length) {
				// 		e['object']=e.object.join(',');
				// 	}else if (typeof e.object=='string') {
				// 		e.object=this_.lang=='cn'?'全部发送':'Send all';
				// 	}
				// });
				this_.list = list;
				this_.pages.count = res.sum;
				this_.isdialog=true;
			})
		},
		class_notice(data){
			this.course_info=data.content;
			this.editFormVisible=true;
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		guanbitanchu(){
			this.list=[];
			this.$emit("guanbi");
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.html_br a{
	display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/mail_record_list.vue